import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";

const RoleRoute = ({ allowedRoles = [], children }) => {
 const user = useSelector((state) => state.auth?.userDetails);

 let roleName = "";

 if (user) {
 if (typeof user.role === "string") {
 roleName = user.role;
 } else if (Array.isArray(user.role)) {
 roleName = user.role[0]?.name || "";
 } else if (typeof user.role === "object") {
 roleName = user.role.name || "";
 }
 roleName = roleName.toLowerCase();
 }

 const isAllowed = allowedRoles
 .map((r) => r.toLowerCase())
 .includes(roleName);

 useEffect(() => {
 if (user && !isAllowed) {
 Swal.fire({
 title: "Restricted Access",
 text: "You currently don't have access to this feature. Please contact your administrator if access is required.",
 icon: "info",
 confirmButtonText: "OK",
 confirmButtonColor: "#3085d6",
 });
 }
 }, [user, isAllowed]);

 if (!user) {
 return <Navigate to="/" replace />;
 }

 if (!isAllowed) {
 return (
 <div className="text-center mt-5">
 <h4 className="text-danger">Restricted Access</h4>
 <p>You currently don't have access to this feature. Please contact your administrator if access is required.</p>
 </div>
 );
 }

 return children;
};

export default RoleRoute;
